import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  font-size: 14px;\n  display: flex;\n  font-weight: 600;\n  align-items: center;\n  line-height: 22px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  color: ",
        ";\n\n  i {\n    margin-right: 2px;\n  }\n\n  p {\n    color: ",
        ";\n  }\n\n  :hover {\n    transition: background-color 0.3s ease-in-out;\n    background-color: ",
        ";\n  }\n\n  @media (max-width: 768px) {\n    display: flex;\n    justify-content: space-between;\n    border-radius: 6px;\n    margin-bottom: 24px;\n    padding: 9px 12px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "../icon/Icon";
import { PASSES_LANDING } from "@/settings/constant";
import { Bookmark, Sizes } from "../icon/IconList";
import styled from "styled-components";
import Link from "next/link";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
export const PassPromotion = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsxs(MembershipStatusLinkWrapper, {
        href: PASSES_LANDING,
        onClick: ()=>mixpanelEvent("Home Quick Button Clicked", {
                "Button Type": "Pass",
                "Button Name": "이용권 구매",
                url: PASSES_LANDING
            }),
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                icon: Bookmark,
                size: Sizes.xmedium
            }),
            /*#__PURE__*/ _jsx("p", {
                children: "이용권 구매"
            }),
            children
        ]
    });
};
export const MembershipStatusLinkWrapper = styled(Link).withConfig({
    componentId: "sc-e85cbc06-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_indigo_500, (props)=>props.theme.new.colors.sol_indigo_500, (props)=>props.theme.new.colors.sol_indigo_50);
